/* global Metafans_JS, showNotification */
import { favoriteMarkup, pinMarkup } from './templates.js';

function activityOptionOpenHandler(icon) {
    const container = icon.closest('.activity-extension-links');
    if (!container) return;
    const isOpen = container.classList.contains("ac-action-open");
    document.querySelectorAll(".activity-extension-links").forEach((cur) => {
        cur.classList.remove("ac-action-open");
    });
    if (!isOpen) {
        container.classList.add("ac-action-open");
    }
}

function activityDeleteActionHandler(deletIcon, e) {
    e.preventDefault();
    e.stopPropagation();
    var activity_id = deletIcon.getAttribute("data-id");
    const popup = document.querySelector(".mf-alert-popup.activity-delete");
    if (!popup) return;

    const titleEl = popup.querySelector(".alert-popup-head h6");
    if (titleEl) titleEl.textContent = "Delete Post?";

    const confirmBtn = popup.querySelector(".confirm-delete-activity");
    if (confirmBtn) {
        confirmBtn.dataset.id = activity_id;
        delete confirmBtn.dataset.commentId;
        delete confirmBtn.dataset.replyId;
    }
    popup.classList.add("open");
}

async function handleDeleteConfirmation(confirmBtn) {
    const activity_id = confirmBtn.dataset.id;
    const popup = confirmBtn.closest(".mf-alert-popup");
    if (popup) popup.classList.remove("open");
    if (!activity_id) return;

    const payload = new URLSearchParams({
        action: "mf_activity_delete",
        activity_id: activity_id,
    });

    try {
        const response = await fetch(Metafans_JS.ajaxurl, { method: "POST", body: payload });
        const data = await response.json();
        if (typeof showNotification === 'function') {
            showNotification(data.response_type, data.response_msg);
        }
        if (data.response_type === 'success') {
            const deletedActivityEl = document.querySelector(`.activity-item[data-bp-activity-id="${activity_id}"]`);
            if (deletedActivityEl) {
                deletedActivityEl.style.transition = "opacity 0.3s ease";
                deletedActivityEl.style.opacity = "0";
                setTimeout(() => deletedActivityEl.remove(), 300);
            }
        }
    } catch (error) {
        console.error("Failed to delete activity:", error);
    }
}

function activityFavoriteActionHandler(favoriteIcon, e, mode) {
    const activityItem = e.target.closest(".activity-item");
    if (!activityItem) return;
    const { bpActivityId } = activityItem.dataset;
    if (!bpActivityId) return;

    const btn = favoriteIcon.closest('a');
    const li = btn.closest('li');
    let newMarkup = (mode === "add") ? favoriteMarkup.unsave : favoriteMarkup.save;
    const isBbPress = activityItem.classList.contains('bbp_topic_create') || activityItem.classList.contains('bbp_reply_create');
    if (!isBbPress) newMarkup = newMarkup.replace('bp-tooltip', '');
    if (li) li.outerHTML = newMarkup;

    const dropdown = activityItem.querySelector('.activity-extension-links');
    if (dropdown) dropdown.classList.remove('ac-action-open');

    jQuery.ajax({
        type: "post",
        url: Metafans_JS.ajaxurl,
        data: {
            activity_id: bpActivityId,
            action: "th_bp_add_favourite_activity",
            action_type: mode,
        },
        success: function (res) {
            if (typeof showNotification === 'function') showNotification("success", res);
        },
        error: function (err) {
            if (typeof showNotification === 'function') showNotification("error", "Action failed");
        }
    });
}

function activityPinActionHandler(pinIcon, e, mode) {
    const activityItem = e.target.closest(".activity-item");
    if (!activityItem) return;
    const { bpActivityId } = activityItem.dataset;
    if (!bpActivityId) return;

    // --- 0. Global Cleanup: Remove ANY existing pins visually before adding new one ---
    if (mode === 'add') {
        // 1. Reset ALL "Unpin" buttons to "Pin"
        const allUnpinBtns = document.querySelectorAll('.unpin-activity-to-profile');
        allUnpinBtns.forEach(btn => {
            const li = btn.closest('li');
            if (li) li.outerHTML = pinMarkup.pin;
        });

        // 2. Remove ALL "Pin" icons from headers
        const allPinIcons = document.querySelectorAll('.activity-header svg.pin');
        allPinIcons.forEach(icon => icon.remove());
    }

    // --- 1. Instant Menu Update ---
    const btn = pinIcon.closest('a');
    const li = btn.closest('li');
    let newMarkup = (mode === "add") ? pinMarkup.unpin : pinMarkup.pin;
    if (li) li.outerHTML = newMarkup;

    const dropdown = activityItem.querySelector('.activity-extension-links');
    if (dropdown) dropdown.classList.remove('ac-action-open');

    // --- 2. Real-Time Logic (Move & Icon) ---
    const header = activityItem.querySelector('.activity-header');

    if (mode === "add") {
        if (header && !header.querySelector('.pin')) {
            const pinSvg = `<svg class="pin" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6523 3.57693C13.4199 2.34449 11.3126 3.21735 11.3126 4.96028C11.3126 5.47914 11.1065 5.97674 10.7396 6.34363L9.11887 7.96433C8.75198 8.33122 8.25438 8.53733 7.73552 8.53733C5.99259 8.53733 5.11972 10.6446 6.35216 11.877L8.72844 14.2533L3.21088 19.7709C2.92971 20.0521 2.92971 20.5079 3.21088 20.7891C3.49206 21.0703 3.94794 21.0703 4.22912 20.7891L9.74668 15.2716L12.1229 17.6478C13.3554 18.8802 15.4626 18.0074 15.4626 16.2645C15.4626 15.7456 15.6688 15.248 16.0357 14.8811L17.6564 13.2604C18.0232 12.8935 18.5209 12.6874 19.0397 12.6874C20.7826 12.6874 21.6555 10.5801 20.4231 9.34768L14.6523 3.57693Z" fill="currentColor"/>
            </svg>`;
            const optionsBtn = header.querySelector('.activity-extension-links');
            if (optionsBtn) {
                optionsBtn.insertAdjacentHTML('beforebegin', pinSvg);
            } else {
                header.insertAdjacentHTML('beforeend', pinSvg);
            }
        }

        // B. Move Post to Top
        const parent = activityItem.parentElement;
        if (parent) {
            parent.prepend(activityItem);

            activityItem.style.transition = 'background-color 0.5s ease';
            const originalBg = activityItem.style.backgroundColor;
            activityItem.style.backgroundColor = '#f0f8ff';
            setTimeout(() => activityItem.style.backgroundColor = originalBg, 1000);

            activityItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    } else {
        if (header) {
            const pin = header.querySelector('svg.pin');
            if (pin) pin.remove();
        }
    }

    // --- 3. Background AJAX ---
    jQuery.ajax({
        type: "post",
        url: Metafans_JS.ajaxurl,
        data: {
            activity_id: bpActivityId,
            action: "th_bp_add_pin_activity",
            action_type: mode,
        },
        success: function (res) {
            if (typeof showNotification === 'function') showNotification("success", res);
        },
        error: function (err) {
            if (typeof showNotification === 'function') showNotification("error", "Action failed");
        }
    });
}

function updateSubmitButtonState(sourceElement) {
    const formContent = sourceElement || document.querySelector('.advanced-th-bp-activity-form');
    if (!formContent) return;

    const wrapper = formContent.closest('#whats-new-form') || formContent.closest('form') || document;
    const submitBtn = wrapper.querySelector('#aw-whats-new-submit');
    const preview = wrapper.querySelector('.whats-new-live-preview');

    if (!submitBtn) return;

    const hasContent = formContent.innerText.trim().length > 0;
    const hasMedia = !!preview;

    if (hasContent || hasMedia) {
        submitBtn.removeAttribute('disabled');
        submitBtn.classList.remove('disabled');
    } else {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.classList.add('disabled');
    }
}

export function init() {
    document.addEventListener('input', (e) => {
        if (e.target.matches('.advanced-th-bp-activity-form')) {
            updateSubmitButtonState(e.target);
        }
    });

    updateSubmitButtonState();

    document.addEventListener("click", (e) => {
        const shareBtn = e.target.closest(".th-bp-post-share-button a.activity-share");
        if (shareBtn) {
            e.preventDefault();
            const wrapper = shareBtn.closest('.th-bp-post-share-button');
            const options = wrapper ? wrapper.querySelector('.sharing-options') : null;
            if (options) options.classList.toggle('open');
            return;
        }

        const openBtn = e.target.closest(".open-button");
        if (openBtn) {
            e.preventDefault();
            e.stopPropagation();
            activityOptionOpenHandler(openBtn);
            return;
        }

        const deleteBtn = e.target.closest(".button-activity-delete");
        if (deleteBtn) {
            e.preventDefault();
            activityDeleteActionHandler(deleteBtn, e);
            return;
        }

        const favoriteBtn = e.target.closest(".activity-make-favourite");
        if (favoriteBtn) {
            e.preventDefault();
            activityFavoriteActionHandler(favoriteBtn, e, "add");
            return;
        }

        const unsaveBtn = e.target.closest(".activity-remove-favourite");
        if (unsaveBtn) {
            e.preventDefault();
            activityFavoriteActionHandler(unsaveBtn, e, "delete");
            return;
        }

        const pinBtn = e.target.closest(".pin-activity-to-profile");
        if (pinBtn) {
            e.preventDefault();
            activityPinActionHandler(pinBtn, e, "add");
            return;
        }

        const unpinBtn = e.target.closest(".unpin-activity-to-profile");
        if (unpinBtn) {
            e.preventDefault();
            activityPinActionHandler(unpinBtn, e, "delete");
            return;
        }

        const confirmBtn = e.target.closest(".confirm-delete-activity");
        if (confirmBtn) {
            e.preventDefault();
            if (confirmBtn.dataset.commentId) return;
            handleDeleteConfirmation(confirmBtn);
            return;
        }

        if (e.target.matches(".mf-alert-popup.activity-delete .popup-cancel")) {
            e.preventDefault();
            const popup = e.target.closest(".mf-alert-popup");
            if (popup) popup.classList.remove("open");
            return;
        }

        if (!e.target.closest(".activity-extension-links")) {
            document.querySelectorAll(".activity-extension-links").forEach((cur) => cur.classList.remove("ac-action-open"));
        }

        if (!e.target.closest(".th-bp-post-share-button")) {
            document.querySelectorAll(".sharing-options.open").forEach((el) => el.classList.remove("open"));
        }
    });
}